const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "" // Relative path for production (Vercel/Railway)
    : "http://localhost:8080";

export default API_BASE_URL;
